<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />

    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement :info="basicRequirement" />
    <PositionSummary :info="positionInfo" />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../../../components/AssessmentIsa/AboutTheCompany.vue'

import TestimonialCompany from '../../../components/AssessmentIsa/CompanyTestimonial.vue'
import Landing from '../../../components/AssessmentIsa/LandingAssessment.vue'
import ProgramInfo from '../../../components/AssessmentIsa/ProgramInfo.vue'
import Contact from '../../../components/isaMain/Contact.vue'
import PositionSummary from '../../../components/AssessmentIsa/PositionSummary.vue'
import BasicRequirement from '../../../components/AssessmentIsa/BasicReq.vue'
import Faq from '../../../components/shera/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title1: 'Your first step towards a',
        subTitle: 'Copywriter/ Content Planner',
        spanColor: '#F79323',
        paragraph:
          'Upskill presents this assessment only designed for Copywriter/ Content Planner Take part in this assessment, and get a chance to work at Magnito Digital',
        companyLogo: require('../../../assets/Magnito/m-logo-box.png'),
        quizLink:
          'https://quiz.upskill.com.bd/assessment/3203b381-cfcf-4192-bc96-0bda1b587163?public=true&job=Assessment_Magnito_Content',
        landingImage: require('../../../assets/telmax/Frame.png'),
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar: require('../../../assets/Magnito/m-logo-box.png'),
        info:
          'Magnito Digital is the largest digital agency of Bangladesh with a team of more than 90 people. We are famous for our unconventional company culture. Our experience and massive setup allows us to deliver services at unparalleled scale. We have worked with the largest clients of Bangladesh and have built leading brands in the digital space. It is in our bloodline to solve problems by combining creative strategies with data, content and technology. Our key strength is developing and deploying meaningful digital contents to engage with the right audience. Thanks to this, we have become the specialized go-to-agency with proven track records, for managing large scale digital products & services. Being one of the most awarded digital agencies of Bangladesh, Magnito Digital won Gold to become the ‘Campaign Asia-Pacific : Digital Agency of the Year 2015’ in the ‘Rest of South Asia’ category.',
        designation: '',

        bgColor: '#F79323',
        txtColor: '#29292B',
      },
      programData: {
        headingInfo:
          'Assessment Test for the role of Account Manager at Magnito Digital consists of approximately 15 MCQs. You are required to pass an assessment test with a minimum 60% of the total score. ',
        seatsInfo:
          'Top 5-10 Candidates will get the chance to go to the interview round directly after completing the assessment . So, don’t miss this opportunity as the time is limited!',
        startDate: '2nd February',
        cost: 'Free',
        deadline: '8th February',
        courseOutlineLink:
          'https://upskill-files.s3.ap-southeast-1.amazonaws.com/Financial+Analyst/Course+Outline+for+Financial+Analyst.pdf',

        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        bgColor: '#F79323',
        txtColor: '#F79323',
      },
      positionInfo: {
        //   paragraph:
        //     'Seeking a creative Sr. Software Developer with 5+ years of software development experience with web technologies including HTML5, CSS3 and JavaScript and Golang. You will apply software design principles and patterns to develop a suite of sales applications. Your extensive project experience and leadership will mentor junior developers. If you’re seeking a challenging role and striving to elevate your career, join the Telmax team!',
        //   remote: 'This is a remote position.',
        //   jobType: 'Job Type: Full-time (Remote)',
        //   txtColor: '#5277F7',
      },
      companyTestimonial: {
        mainImg: require('../../../assets/Magnito/dhaly 1.png'),
        name: 'Ishraq Dhaly',
        paragraph:
          'If you want to join the digital agency that powers the revolution and work with the best brands of the country, Magnito Digital is your only choice. What are you waiting for? Join us now!',
        designation: 'Director - Accounts & Servicing, Magnito Digital Ltd',
        imgBg: '',
        invertedCommaBg: '',
        firstComma: require('../../../assets/Magnito/“.svg'),
        secondComma: require('../../../assets/Magnito/Group 22.svg'),
      },
      basicRequirement: {
        mainContent: [
          'The ability to write good, clear copy in a variety of styles with accurate spelling and grammar;',
          'Bachelor’s degree in any field',
          '1 year of experience working in the Content/Copy department of an advertising agency preferred',
          'Proficient in both Bangla &amp; English',
          'Excellent teamwork, communication and interpersonal skills;',
          'Accuracy and attention to detail;',
          'An interest in popular culture, new trends and styles and good research skills;',
        ],

        bgColor: '#F79323',
      },

      outlineColor: {
        color: '#EA4424',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content: 'It is free',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content:
            'Minimum 5+ years front-end/back-end development experience.. \n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score i.e. 6 out of 10',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.\n',
          category: 'FAQ',
        },
        {
          title: 'Will all the top 5 students get a job at Magnito?\n',
          content:
            'No, the top 5 students will get a chance to interview at Magnito, and will get the job depending on their performance in the interview.\n',
          category: 'FAQ',
        },
        {
          title: 'Salary?\n',
          content: ' Negotiable \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
    PositionSummary,
  },
  created() {
    this.Loaded()
  },
}
</script>
